export default {
  SettingIndexesList: {
    indexCode: 'Index',
    remark: 'Description',
    copyIndex: 'Copy index',
    updateUser: 'Last updater',
    lastUpdateDate: 'Last update time',
    msgError: 'Copy failed',
    msgSuccess: 'Modified successfully',

    details: {
      title: 'Account Information',
      shards: 'Sharding count',
      replicas: 'Replica count',
      syncField: 'Synchronized fields',
      fieldName: 'Field name',
      fieldType: 'Field type',
      analyzerFlag: 'Indexed',
      filedAnalyzerCode: 'Analyzer',
      pkFlag: 'Primary key',
      msgRulesText: 'Please enter index',
      alertMsgText: 'Please enter synchronized field information'
    }
  }
};
